module.exports = "<div class=\"popup-wrap overlay-request-indicator\" [hidden]=\"!isRequesting\">\t\r\n<img src=\"/assets/resources/img/loading.gif\" id=\"request-indicator\">\r\n</div>\r\n<div class=\"body-wrap\">\r\n\t<div class=\"body-container\">\r\n\t\t<router-outlet></router-outlet>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main